import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { RingLoader } from 'react-spinners';
import { ClipLoader } from 'react-spinners';
import { BeatLoader } from 'react-spinners';
import { useDispatch, useSelector } from 'react-redux';
import { suspendLicenses,  reinstateLicenses, deleteLicenses} from '../../../redux/actions/licenses/licenseActions';
import './licenses.css';
import { listLicenses } from '../../../redux/actions/licenses/licenseActions';
import LicenseCreateForm from './LicenseCreateForm';
import { canAccess, webURL } from '../../../config';
import { url } from '../../../api/endpointURL';
// Import generic components
import Select from '../../../generic_components/Select/Select';
import Tooltip from '../../../generic_components/Tooltip/Tooltip';
import Table from '../../../generic_components/Table/Table';
import Input from '../../../generic_components/Input/Input';
import Modal from '../../../generic_components/Modal/Modal';
import Footer from '../../../generic_components/Footer/Footer';
import { useToast } from '../../../generic_components/Toast/Toast';

const Licneses = () => {
  const [modalOpenCreate, setModalOpenCreate] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState('All');
  const [selectedSite, setSelectedSite] = useState('All');
  const [selectedUser, setSelectedUser] = useState('All');
  const [selectedPolicy, setSelectedPolicy] = useState('All');
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [copiedToken, setCopiedToken] = useState(null);

  const dispatch = useDispatch();

  const isSmallScreen = window.innerWidth < 700;

  const toast = useToast();  

  const { licenses, loading, error } = useSelector(state => state.licenses);
  
  const businessTokenMappingData = useSelector(state => state.businessTokenMapping);
  const fetchUserResponse = useSelector(state => state.fetchUserResponse);

  // get user role
  const userRole = fetchUserResponse?.role?.toLowerCase();

    // handle copy text to clipboard
  const handleCopyText = (e, text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopiedToken(text);
          setTimeout(() => setCopiedToken(null), 300); // Reset copied state after 1.5 seconds
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    } else {
      console.warn('Clipboard API not supported');
      // Fallback method, e.g., using a temporary textarea element
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        setCopiedToken(text);
        setTimeout(() => setCopiedToken(null), 300);
      } catch (err) {
        console.error('Fallback copy failed: ', err);
      }
      document.body.removeChild(textarea);
    }
  };

let uniqueBusinesses = ['All', ...new Set(licenses?.map(license => license.business))];

// update uniqueBusinesses if not blank
uniqueBusinesses = uniqueBusinesses.filter(item => item !== null && item !== '');  


// Count the number of licenses for each business
const businessCounts = licenses.reduce((acc, license) => {
  acc[license.business] = (acc[license.business] || 0) + 1;
  return acc;
}, {});
// Remove "All" from uniqueBusinesses before sorting
const sortedBusinesses = uniqueBusinesses.slice(1).sort((a, b) => businessCounts[b] - businessCounts[a]);
// Add "All" back at the beginning
const sortedUniqueBusinesses = ['All', ...sortedBusinesses];


  // filter by business
  let filteredByBusiness = selectedBusiness === 'All' ? 
    licenses :
    licenses.filter(
      license => license.business === selectedBusiness
    );

  // update license.business if it is not blank and remove them
  filteredByBusiness = filteredByBusiness.filter(item => item.business !== null && item.business !== '');

    // filter by site
  let filteredBySite = selectedSite === 'All' ? 
    filteredByBusiness : 
    filteredByBusiness.filter(
      license => license.site === selectedSite
  );

  // sort filtered sites alphabetically from filteredBySite
  const sortedSites = ['All', ...new Set(filteredByBusiness.map((license) => license.site).filter(site => site !== null && site !== '').sort())];

  // Fetch unique users from the filtered business list
  const uniqueUsers = ['All', ...new Set(filteredByBusiness.map((license) => license.user))];
  
  // filter by user
   const filteredByUser = selectedUser === 'All' ? 
   filteredBySite : 
   filteredBySite.filter(
     license => license.user === selectedUser
   );

   // Update license.user if it is blank
  const updatedFilteredByUser = filteredByUser.map(license => {
    if (!license.user) {
      license.user = 'unknown'; // or any default value you prefer
    }
    return license;
  });

  // filter by policy
  let filteredByPolicy = selectedPolicy === 'All' ?
    updatedFilteredByUser :
    updatedFilteredByUser.filter(
      license => license.policy === selectedPolicy
    );

  // get unique policies
  const uniquePolicies = ['All', ...new Set(updatedFilteredByUser.map((license) => license.policy))];


  // filter by status
  let filteredByStatus = selectedStatus === 'All' ? 
    filteredByPolicy :
    filteredByPolicy.filter(
      license => license.status === selectedStatus
  );

  // get unique statuses
  const uniqueStatuses = ['All', ...new Set(filteredByPolicy.map((license) => license.status))];

    //Modal toggle settings for create tag
    const handleModalOpenCreate = () => { 
    setModalOpenCreate(true);
    window.localStorage.setItem('license_key', '');
  };
    const handleModalCloseCreate = () => {
      setModalOpenCreate(false);
      localStorage.removeItem('newLicenses');
  };

    const handleRefresh = () => {
    setIsRefreshing(true);
    dispatch(listLicenses());
  };

  useEffect(() => {
    if (!loading.ListLicenses) {
      setIsRefreshing(false);
    }
  }, [loading.ListLicenses]);


  // select a business
  const handleBusinessChange = (event) => {
    setSelectedBusiness(event.target.value);
    setSelectedSite('All');
    setSelectedUser('All');
    setSelectedPolicy('All');
  };

  // select a site
  const handleSiteChange = (event) => {
    setSelectedSite(event.target.value);
    setSelectedUser('All');
    setSelectedPolicy('All');
  };

  // select a policy
  const handlePolicyChange = (event) => {
    setSelectedPolicy(event.target.value);
  };

  // select a status
  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  // select a user
  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
    setSelectedPolicy('All');
  };

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const searchedLicenses = filteredByStatus.filter(license =>
    license.license_key.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCearSearch = () => {
    setSearchTerm('');
  };

  useEffect(() => {
    setIsFirstLoad(true);
    dispatch(listLicenses());
  }, [dispatch]);

   // show error via toast notification
   useEffect(() => {
    if (error) {
      toast.error(error, { hideProgressBar: true });
    }
  }, [error, toast]);

  // set selected business to 'All' if the updatedFilteredByUser becomes empty
  useEffect(() => {
    if (updatedFilteredByUser.length === 0) {
      setSelectedBusiness('All');
    }
  }, [updatedFilteredByUser]);

  // Fetch RBAC business-roles
  const fetchAndStoreRBAC = async (email) => {
      try {
          const url_path = url+'/fetch_rbac'; // Use environment variable or default to localhost
          const response = await fetch(url_path, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ user: email })
          });
          
          const rbacResponse = await response.json();
          // console.log("RBAC fetched:", rbacResponse);
      
          // Store in localStorage for persistence
          localStorage.setItem('rbac_role', rbacResponse.global_role);
          localStorage.setItem('rbac_data', JSON.stringify(rbacResponse.business_roles));
          return rbacResponse;
      } catch (error) {
          console.error('Error fetching RBAC data:', error);
      }
  };
  
  // SINGLE useEffect for initialization
  useEffect(() => {
      const email = localStorage.getItem('email');
      
      if (!email) {
          // window.location.href = '/#auth/signin';
          return;
      }
      
      const initializeData = async () => {
          try {
          // Fetch RBAC data first
          await fetchAndStoreRBAC(email);
              
          } catch (error) {
          console.error('Error loading initial data:', error);
          } finally {
          }
      };
      
      initializeData();
  }, []); // Empty dependency array - run once only

  const sortedUniqueBusinessesOptions = sortedUniqueBusinesses.map((business, index) => (
    {
      label: business,
      value: business
    }
  ));

  const sortedSitesOptions = sortedSites.map((site, index) => (
    {
      label: site,
      value: site
    }
  ));

  const uniqueUsersOptions = uniqueUsers.map((user, index) => (
    {
      label: user,
      value: user
    }
  ));

  const uniquePoliciesOptions = uniquePolicies.map((policy, index) => (
    {
      label: policy,
      value: policy
    }
  ));

  const uniqueStatusesOptions = uniqueStatuses.map((status, index) => (
    {
      label: status,
      value: status
    }
  ));

  //                                   *** License Component ***            
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSuspendConfirmation, setShowSuspendConfirmation] = useState(false);
  const [selectedActionLicenseKey, setSelectedActionLicenseKey] = useState('');
  const [selectedLicense, setSelectedLicense] = useState('');

  const signedInUser = localStorage.getItem('email');

  const handleSuspend = (license) => {
    setSelectedLicense(license);
    setShowSuspendConfirmation(true);
  };

  const confirmSuspend = (licenseKey) => {
    setSelectedActionLicenseKey(licenseKey);
    dispatch(suspendLicenses({ key: licenseKey, eventCreator: signedInUser }));
    // Hide the confirmation dialog after deletion
    setShowSuspendConfirmation(false);
  };

  const cancelSuspend = () => {
    // Hide the confirmation dialog if cancel is clicked
    setShowSuspendConfirmation(false);
  };

  const handleReinstate = (license) => {
    setSelectedActionLicenseKey(license.license_key);
    dispatch(reinstateLicenses({ key: license.license_key, eventCreator: signedInUser }));
  };

  const handleDelete = (license) => {
    setSelectedLicense(license);
    setShowConfirmation(true);
  };

  const confirmDelete = (licenseKey) => {
    setSelectedActionLicenseKey(licenseKey);
    // Perform delete action
    const license_key = licenseKey ? licenseKey : 'blank';
    dispatch(deleteLicenses({ key: license_key, eventCreator: signedInUser }));
    // Hide the confirmation dialog after deletion
    setShowConfirmation(false);
  };
  
  const cancelDelete = () => {
    // Hide the confirmation dialog if cancel is clicked
    setShowConfirmation(false);
  };

  useEffect(() => {
    if (!loading.deleteLicense) {
      setSelectedActionLicenseKey('');
    }
  }, [loading.deleteLicense]);

  useEffect(() => {
    if (!loading.suspendLicense) {
      setSelectedActionLicenseKey('');
    }
  }, [loading.suspendLicense]);

  useEffect(() => {
    if (!loading.reinstateLicense) {
      setSelectedActionLicenseKey('');
    }
  }, [loading.reinstateLicense]);

  // convert utc time into human readable local time
  const utcStrToLocal = (utcTimestamp) => {
    // Create a Date object using the UTC timestamp
    const utcDate = new Date(utcTimestamp);

    // Get the local time components
    const localYear = utcDate.getFullYear();
    const localMonth = utcDate.getMonth() + 1; // Months are zero-based
    const localDay = utcDate.getDate();
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const localSeconds = utcDate.getSeconds();

    // Create a new Date object with the local time components
    const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);

    // Format the local time as needed
    const formattedLocalTime = localDate.toLocaleString();

    return formattedLocalTime
  }


  // Headers for license table
  const license_table_columns = [
    { key: 'licenseKey', label: 'License Key' },
    { key: 'name', label: 'License Name' },
    { key: 'site', label: 'Site' },
    { key: 'assigned_server_name', label: 'Server' },
    { key: 'status', label: 'Status' },
    { key: 'user', label: 'User' },
    { key: 'updated', label: 'Updated' },
    { key: 'actions', label: 'Actions' }
  ];

  // Data for license table
  const license_table_data = searchedLicenses.length && searchedLicenses?.map((license, index) => {
    let statusColor = '#ccc';
    if (license.status === 'SUSPENDED') {
      statusColor = '#ffc107';
    }
    if (license.status === 'ACTIVE') {
      statusColor = '#22BE63';
    }

    const toolTipText = `Policy: ${license.policy}`;
    
    return (
    {
      licenseKey: ( 
                    <div>
                      <span style={{ marginRight: '10px' }}>
                        {license?.license_key?.substring(0, 6)}...
                      </span>
                      <button
                        className='business-token-table-btn-copy'
                        title="Copy this token"
                        onClick={(e) => handleCopyText(e, license.license_key)}
                        >
                        <i className="fa-solid fa-copy fa-lg" style={{ color: copiedToken === license.license_key ? 'black' : '#E8E8E8'}}></i>
                      </button>
                    </div>
                  ),
      name: (
        <>
          <Tooltip content={ toolTipText } placement='top'>
            <span className='info-icon'></span>
          {/* </CustomTooltipName>           */}
          </Tooltip>
          {license.name}
        </>
      ),
      site: license.site,
      assigned_server_name: license.assigned_server_name,
      status: (
        <span style={{ color: statusColor }}>{license.status}</span>
      ),
      user: license.user,
      created: utcStrToLocal(license.created),
      updated: utcStrToLocal(license.updated),
      actions: (
        <div className='license-actions'>
            <div>
              <Button id='license-action-btn' variant='warning' disabled={license.status === 'SUSPENDED' || !canAccess("suspend-reinstate-delete-license", userRole)} onClick={() => handleSuspend(license)}>Suspend</Button>
              {
                selectedActionLicenseKey === license.license_key && loading.suspendLicense && 
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ marginTop: '1em' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div>
                </div>
              }
              </div>
            <div>
              <Button id='license-action-btn' variant='success' disabled={license.status === 'ACTIVE' || !canAccess("suspend-reinstate-delete-license", userRole)} onClick={() => handleReinstate(license)}>Reinstate</Button>
              {
                selectedActionLicenseKey === license.license_key && loading.reinstateLicense &&  
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ marginTop: '1em' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div>
                </div>
              }
            </div>

            <div>
              <Button id='license-action-btn' variant='danger' onClick={() => handleDelete(license)} disabled={!canAccess("suspend-reinstate-delete-license", userRole)}>
                Delete
              </Button>
              
              { 
                selectedActionLicenseKey === license.license_key && loading.deleteLicense && 
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ marginTop: '0.3em' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div>
                </div>
              }
            </div>
        </div> 
      ),
    })
  });

  return (
  <>
   {/* hide sidebar for the small screen */}
  <div className='license-header-container'>
    <div className='license-header-text'>
      Licenses
    </div>
  </div>

  { ((!loading.listLicenses || isRefreshing) && (isFirstLoad && filteredByPolicy.length)) || localStorage.getItem('newLicenses') ? 
   
    <div className='license-page-container'>
      {canAccess("create-new-licenses", userRole) &&
      <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
        <Button variant='dark' style={{ fontSize: '0.88em' }} onClick={handleModalOpenCreate}>Create new licenses</Button>
      </div>
      }
      <div className='license-container'>
        {/* select site dropdown menu */}
        <div className='license-select-container'>

          <div className='license-business-select-container'>
            <Select
              className="license-info-dropdown"
              label="Filter by business"
              value={selectedBusiness}
              onChange={handleBusinessChange}
              options={sortedUniqueBusinessesOptions}
              size='sm'
            />
          </div>

          <div className='license-business-select-container'>
            <Select
              className="license-info-dropdown"
              label="Filter by site"
              value={selectedSite}
              onChange={handleSiteChange}
              options={sortedSitesOptions}
              size='sm'
            />
          </div>          

          <div className='license-business-select-container'>
            <Select
              className="license-info-dropdown"
              label="Filter by user"
              value={selectedUser}
              onChange={handleUserChange}
              options={uniqueUsersOptions}
              size='sm'
            />
          </div>

          <div className='license-business-select-container'>
            <Select
              className="license-info-dropdown"
              label="Filter by policy"
              value={selectedPolicy}
              onChange={handlePolicyChange}
              options={uniquePoliciesOptions}
              size='sm'
            />
          </div>

          <div className='license-business-select-container'>
            <Select
              className="license-info-dropdown"
              label="Filter by status"
              value={selectedStatus}
              onChange={handleStatusChange}
              options={uniqueStatusesOptions}
              size='sm'
            />
          </div>

        </div>

        <div className="total-licenses-container">
          <button onClick={handleRefresh} className='refresh-icon-container'>
            <span>&#x21bb;</span>
          </button>
          <div className='total-license'>Total licenses: {searchedLicenses.length}</div>
        </div>

        {/* search box to fetch licenses given licnese key */}
      
        <div className="search-container">
            <Input 
              className="search-box"
              value={searchTerm}
              onChange={handleSearchTermChange}
              placeholder="Search license key ..."
            />
            {searchTerm && (
              <span
                className="clear-icon"
                onClick={() => handleCearSearch()}
              >
                &times; {/* This is the "X" icon */}
              </span>
            )}
          </div>

        {
          loading.listLicenses && !error &&
          <div className='overlay'>
            <ClipLoader size={ !isSmallScreen ? 130 : 70} color="#F49523"/>
          </div>
        }
        { searchedLicenses.length > 0 ?
        <div className='table-container-license'>
          <Table 
            columns = {license_table_columns}
            data = {license_table_data}
            tableWrapperStyle={{maxHeight: '500px'}}
          />
        </div> :
        <div className='no-license-found'>
          No license found!
        </div>
    }
          
      </div>

      {/* create new license modal */}
      <Modal size='lg' show={modalOpenCreate} onHide={handleModalCloseCreate} >
        <Modal.Header closeButton >
            <Modal.Title >Create new licenses</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <LicenseCreateForm licenses={licenses} fetchUserResponse={fetchUserResponse} businessTokenData={businessTokenMappingData}/>
        </Modal.Body>                  
      </Modal>
    </div>
    :
    (!searchedLicenses.length || (loading.listLicenses && !isRefreshing)) &&
    <div className='loading-refresh-lifecycle'>
      <RingLoader size={ !isSmallScreen ? 300 : 200} color="#F49523"/>
    </div>
  }
    {/* suspend license Modal */}
    <Modal size='sm' show={showSuspendConfirmation} onHide={cancelSuspend}>
      <Modal.Header closeButton>
        <Modal.Title>
            Confirm Suspend
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: '1em' }}>
          Are you sure you want to suspend the following license ?
          <div>
            {selectedLicense.name}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {
            <Button variant="danger" size='small' onClick={() => confirmSuspend(selectedLicense.license_key)}>Suspend</Button>
          }
          <Button variant="ghost" size='small' onClick={cancelSuspend}>Cancel</Button>
        </div>
      </Modal.Body>           
    </Modal>

    {/* delete license Modal */}
    <Modal size='sm' show={showConfirmation} onHide={cancelDelete}>
      <Modal.Header closeButton>
        <Modal.Title>
            Confirm Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: '1em' }}>
          Are you sure you want to delete the following license ?
          <div>
            {selectedLicense.name}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {
            <Button variant="danger" size='small' onClick={() => confirmDelete(selectedLicense.license_key)}>Delete</Button>
          }
          <Button variant="ghost" size='small' onClick={cancelDelete}>Cancel</Button>
        </div>
      </Modal.Body>           
    </Modal>
    <div className='superAdmin-footer-container'>
      <Footer url={webURL}/>
    </div>
  </>      
  )
}
export default Licneses